import React, { Dispatch, SetStateAction } from 'react';

type Filters = Array<string>;

interface MaterialsTableContextType {
  selectedFilters: Filters;
  setSelectedFilters: Dispatch<SetStateAction<Filters>>;
  allFilters: Filters;
  filteredTableData: MaterialData[];
  activeColumn: number | boolean;
  handleActiveColumn: (index: number) => void;
  clearActiveColumn: () => void;
  handleRowExpansion: (rowId: string) => void;
  expandedRows: Record<string, boolean>;
}

const defaultValues: MaterialsTableContextType = {
  selectedFilters: [],
  setSelectedFilters: () => {},
  allFilters: [],
  filteredTableData: [],
  activeColumn: false,
  handleActiveColumn: () => {},
  clearActiveColumn: () => {},
  handleRowExpansion: () => {},
  expandedRows: {},
};

export const MaterialsTableContext =
  React.createContext<MaterialsTableContextType>(defaultValues);

export const useMaterialsTableContext = () =>
  React.useContext(MaterialsTableContext);
